import React from 'react'

export const HouseSizeSIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='81'
      height='63'
      viewBox='0 0 81 63'
      className='f-c-st-pri f-c-fi-whi'
      fill='none'>
      <path
        d='M24.0726 1.17944H17.2109V15.8588H24.0726V1.17944Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M79.0742 61.9928H1.07422'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M71.5451 61.9964H8.60327V21.382L40.076 1.17944L71.5451 21.382V61.9964Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.84058 23.7991L40.076 1.17944L75.3079 23.7991'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M75.3115 58.2337H4.84058V62H75.3115V58.2337Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M24.0726 25.6823H17.2109V40.5745H24.0726V25.6823Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M47.4718 31.1732H32.677V57.5844H47.4718V31.1732Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M35.6567 43.5002V46.1482'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M62.941 25.6823H56.0793V40.5745H62.941V25.6823Z'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
